import React from 'react';
import { motion } from 'framer-motion';
import { PieChart, ArrowUpRight, Calendar } from 'lucide-react';
export function RaiseSlide() {
  const allocation = [{
    label: 'Go-to-Market',
    value: '50%',
    color: 'bg-purple-500'
  }, {
    label: 'AI Optimization',
    value: '30%',
    color: 'bg-indigo-500'
  }, {
    label: 'Capability',
    value: '20%',
    color: 'bg-blue-500'
  }];
  return <div className="h-full flex flex-col" data-id="element-302">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 h-full items-center" data-id="element-303">
        {/* Left: Allocation */}
        <div className="space-y-8" data-id="element-304">
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} animate={{
          scale: 1,
          opacity: 1
        }} className="relative aspect-square max-w-[300px] mx-auto" data-id="element-305">
            {/* Simple CSS Pie Chart Representation */}
            <div className="w-full h-full rounded-full bg-gray-100 border-8 border-gray-200 relative overflow-hidden" data-id="element-306">
              <div className="absolute inset-0 bg-purple-500 opacity-20" style={{
              clipPath: 'polygon(50% 50%, 100% 0, 100% 100%, 50% 100%)'
            }} data-id="element-307" />
              <div className="absolute inset-0 bg-indigo-500 opacity-20" style={{
              clipPath: 'polygon(50% 50%, 0 100%, 50% 100%)'
            }} data-id="element-308" />
              <div className="absolute inset-0 bg-blue-500 opacity-20" style={{
              clipPath: 'polygon(50% 50%, 0 0, 0 100%)'
            }} data-id="element-309" />

              <div className="absolute inset-0 flex items-center justify-center flex-col" data-id="element-310">
                <div className="text-4xl font-bold text-gray-900" data-id="element-311">€2M</div>
                <div className="text-sm text-gray-500" data-id="element-312">Raise</div>
              </div>
            </div>
          </motion.div>

          <div className="space-y-4" data-id="element-313">
            {allocation.map((item, idx) => <motion.div key={idx} initial={{
            x: -20,
            opacity: 0
          }} animate={{
            x: 0,
            opacity: 1
          }} transition={{
            delay: 0.2 + idx * 0.1
          }} className="flex items-center justify-between p-3 rounded-lg bg-gray-50 border border-gray-200" data-id="element-314">
                <div className="flex items-center gap-3" data-id="element-315">
                  <div className={`w-3 h-3 rounded-full ${item.color}`} data-id="element-316" />
                  <span className="text-gray-600" data-id="element-317">{item.label}</span>
                </div>
                <span className="font-mono font-bold text-gray-900" data-id="element-318">
                  {item.value}
                </span>
              </motion.div>)}
          </div>
        </div>

        {/* Right: Outcome & Timeline */}
        <div className="space-y-8" data-id="element-319">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.4
        }} className="p-6 rounded-2xl bg-purple-50 border border-purple-200" data-id="element-320">
            <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center gap-2" data-id="element-321">
              <ArrowUpRight className="w-5 h-5 text-purple-600" data-id="element-322" />
              The Outcome
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-323">
              A scalable AI-native agency with compounding learning dynamics and
              recurring runtime revenue.
            </p>
          </motion.div>

          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 0.6
        }} className="space-y-4" data-id="element-324">
            <div className="flex items-center gap-2 text-gray-400 text-sm uppercase tracking-wider mb-2" data-id="element-325">
              <Calendar className="w-4 h-4" data-id="element-326" />
              Milestones 2026
            </div>

            <div className="relative pl-6 border-l border-gray-200 space-y-6" data-id="element-327">
              <div className="relative" data-id="element-328">
                <div className="absolute -left-[29px] top-1 w-3 h-3 rounded-full bg-purple-500" data-id="element-329" />
                <div className="text-gray-900 font-medium" data-id="element-330">Q2 2026</div>
                <div className="text-sm text-gray-500" data-id="element-331">Pipeline Conversion</div>
              </div>
              <div className="relative" data-id="element-332">
                <div className="absolute -left-[29px] top-1 w-3 h-3 rounded-full bg-indigo-500" data-id="element-333" />
                <div className="text-gray-900 font-medium" data-id="element-334">Q3 2026</div>
                <div className="text-sm text-gray-500" data-id="element-335">ARR Milestones</div>
              </div>
              <div className="relative" data-id="element-336">
                <div className="absolute -left-[29px] top-1 w-3 h-3 rounded-full bg-blue-500" data-id="element-337" />
                <div className="text-gray-900 font-medium" data-id="element-338">Q4 2026</div>
                <div className="text-sm text-gray-500" data-id="element-339">
                  Enterprise Expansion
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>;
}